import { getApi } from '../apiClient';
import {
  IProgressStatsResponse,
  IRewardsResponse,
  IVocabularyProgressResponse,
  IComparativeStatResponse,
  IGoalsResponse,
  ILeaderboardParams,
  ILeaderboardResponse
} from './types';

export async function getProgressStats(
  period?: 'week' | 'month' | 'year'
): Promise<IProgressStatsResponse> {
  const { data } = await getApi().get<IProgressStatsResponse>('/profile/progress', {
    params: period ? { period } : undefined
  });
  return data;
}

export async function getRewards(): Promise<IRewardsResponse> {
  const { data } = await getApi().get<IRewardsResponse>('/profile/rewards');
  return data;
}

export async function getVocabularyProgress(): Promise<IVocabularyProgressResponse> {
  const { data } = await getApi().get<IVocabularyProgressResponse>('/profile/vocabulary');
  return data;
}

export async function getComparativeStat(): Promise<IComparativeStatResponse> {
  const { data } = await getApi().get<IComparativeStatResponse>('/profile/comparative');
  return data;
}

export async function getGoals(): Promise<IGoalsResponse> {
  const { data } = await getApi().get<IGoalsResponse>('/profile/goals');
  return data;
}

export async function getLeaderboard({
  dimension,
  period
}: ILeaderboardParams): Promise<ILeaderboardResponse> {
  const { data } = await getApi().get<ILeaderboardResponse>('/profile/leaderboard', {
    params: { dimension, period }
  });
  return data;
}
